import React from 'react';

import {updateAndRunAnalysisStep} from 'analysis-tool/AnalysisActions';
import {SINGLE_DATASET_INPUT_STEP_DATA_NAME} from 'analysis-tool/AnalysisStepDataNames';
import {findAndAssertSingleStepDataFrameId} from 'analysis-tool/data/findAndAssertStepDataFrameIds';
import {getVisualizationConfigGQLFromStep} from 'analysis-tool/data/StepConfigUtils';
import getPersistedVisualizationConfig from 'analysis-tool/ui/charting/getPersistedVisualizationConfig';
import VisualizationStepEditor from 'analysis-tool/ui/charting/VisualizationStepEditor';
import {VisualizationConfig} from 'insights/universal-blocks/SharedUniversalBlockViewTypes';
import {getTableLineageAncestorSteps} from 'pipelines/StepLineageUtils';
import {withLoadingScreen} from 'util/Promises';

import {AnalysisMainViewItemType, MainViewComponentProps} from './MainViewTypes';

export default function EditVisualizationView({
  analysis,
  clientStateId,
  onCloseStepInitializationView,
  step: visualizationStep,
}: MainViewComponentProps<AnalysisMainViewItemType.EDIT_VISUALIZATION>): JSX.Element | null {
  const {visualizationConfig: initialVisualizationConfig, visualizationName: initialVisualizationName} =
    getVisualizationConfigGQLFromStep(visualizationStep);
  const inputDataFrameId = findAndAssertSingleStepDataFrameId(
    visualizationStep,
    SINGLE_DATASET_INPUT_STEP_DATA_NAME,
    true
  );
  const viewSteps = getTableLineageAncestorSteps(analysis, visualizationStep);

  async function handleSaveChart(
    visualizationConfig: VisualizationConfig,
    visualizationName: string
  ): Promise<void> {
    const newStep = await withLoadingScreen(
      updateAndRunAnalysisStep(analysis.id, {
        stepId: visualizationStep.id,
        stepConfig: {
          visualizationConfig: getPersistedVisualizationConfig(visualizationConfig),
          visualizationName,
        },
      }),
      'Updating view...'
    );

    onCloseStepInitializationView({type: AnalysisMainViewItemType.VISUALIZATION, stepId: newStep.id});
  }

  return (
    <VisualizationStepEditor
      analysis={analysis}
      clientStateId={clientStateId}
      inputDataFrameId={inputDataFrameId}
      handleSaveChart={handleSaveChart}
      viewSteps={viewSteps}
      initialVisualizationConfig={initialVisualizationConfig}
      initialVisualizationName={initialVisualizationName}
    />
  );
}
